<mat-card appearance="outlined" class="default-card">
    <mat-card-header>
        <mat-card-title>{{ data.id ? "Edition d'un rappel" : "Ajout d'un rappel" }}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="container">
            <div class="form-item">
                <mat-form-field class="mat-form-field-name">
                    <mat-label>Nom</mat-label>
                    <input matInput [formControl]="nameFormControl" autocomplete="off" required />
                    @if (nameFormControl?.errors?.required && (nameFormControl?.dirty || nameFormControl.touched)) {
                        <mat-error>Le champ 'Nom' est obligatoire.</mat-error>
                    }
                </mat-form-field>
            </div>

            <div class="form-item">
                <mat-form-field class="mat-form-field-first-occurence">
                    <mat-label>Date du rappel</mat-label>
                    <input
                        matInput
                        [ngxMatDatetimePicker]="datetimepicker"
                        [formControl]="firstOccurenceFormControl"
                        autocomplete="off"
                        (blur)="validateControl()"
                        (focus)="validateControl()"
                        (dateChange)="validateControl()" />
                    <mat-datepicker-toggle matSuffix [for]="datetimepicker"></mat-datepicker-toggle>
                    <ngx-mat-datetime-picker #datetimepicker></ngx-mat-datetime-picker>
                    @if (firstOccurenceFormControl?.errors?.matDatepickerParse && (firstOccurenceFormControl?.dirty || firstOccurenceFormControl.touched)) {
                        <mat-error>La date n'est pas valide.</mat-error>
                    }
                </mat-form-field>
            </div>
            <div class="form-item">
                <mat-checkbox class="primary-button" [formControl]="isRepeated">Répéter le rappel</mat-checkbox>
            </div>

            <div class="form-item">
                <mat-form-field class="mat-form-field-frequency">
                    <mat-label>Intervalle entre les répétitions</mat-label>
                    <input matInput type="text" [formControl]="frequencyFormControl" autocomplete="off" (focusout)="onDurationChange($event.target.value)" />
                    @if (frequencyFormControl.hasError('required') && (frequencyFormControl?.dirty || frequencyFormControl?.touched)) {
                        <mat-error>L'intervalle entre les répétitions est obligatoire</mat-error>
                    }
                    @if (frequencyFormControl.hasError('pattern') && (frequencyFormControl?.dirty || frequencyFormControl?.touched)) {
                        <mat-error data-input-unitPrice-error>L'intervalle entre les répétitions est incorrect</mat-error>
                    }
                </mat-form-field>
            </div>
            <div class="form-item">
                <mat-form-field class="mat-form-field-max-occurences">
                    <mat-label>Nombre de répétitions</mat-label>
                    <input matInput type="text" [formControl]="maxOccurencesFormControl" autocomplete="off" />
                    @if (maxOccurencesFormControl?.errors?.pattern && (maxOccurencesFormControl?.dirty || maxOccurencesFormControl.touched)) {
                        <mat-error>Le champ 'Nombre de répétitions' doit être un entier.</mat-error>
                    }
                </mat-form-field>
            </div>

            <div class="form-item">
                <mat-form-field class="mat-form-field-action-type">
                    <mat-label>Type de rappel</mat-label>
                    <mat-select [formControl]="reminderActionTypeFormControl" (selectionChange)="onReminderTypeChange($event.value)" required>
                        <mat-option [value]="ReminderActionType.DisplayNotification">Affichage d'une notification</mat-option>
                        <mat-option [value]="ReminderActionType.SendMail">Envoi d'un mail</mat-option>
                    </mat-select>
                    @if (reminderActionTypeFormControl?.errors?.required && (reminderActionTypeFormControl?.dirty || reminderActionTypeFormControl.touched)) {
                        <mat-error>Le champ 'Type de rappel' est obligatoire.</mat-error>
                    }
                </mat-form-field>
            </div>
            <ng-template reminderDataHost></ng-template>
        </div>
    </mat-card-content>
    <mat-card-actions>
        <button mat-stroked-button class="accent-button" (click)="cancel()">Annuler</button>
        <button mat-raised-button class="accent-button" (click)="validate()" [disabled]="!isValid">Enregistrer</button>
    </mat-card-actions>
</mat-card>
<ngx-spinner name="add-reminder-spinner" [fullScreen]="false" type="timer" size="medium"></ngx-spinner>
